import { configureStore } from '@reduxjs/toolkit';
import { productApi } from 'api/productApi';
import { contactApi } from 'api/contactApi';
import { blogApi } from 'api/blogApi';
import { eventApi } from 'api/eventApi';
const store = configureStore({
    reducer: {
        [productApi.reducerPath]: productApi.reducer,
        [contactApi.reducerPath]: contactApi.reducer,
        [blogApi.reducerPath]: blogApi.reducer,
        [eventApi.reducerPath]: eventApi.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            productApi.middleware,
            contactApi.middleware,
            blogApi.middleware,
            eventApi.middleware,
        ),
});

export default store;
